import { BaseRouteService } from 'core/services';

class InventoryRequestRouteService extends BaseRouteService {
    constructor() {
        super('inventory-request');
    }

    download() {
        return super.find(this.base + '/download');    
    }

    getEmailPrefillData(id, inventoryRequestType) {
        return super.get(this.base + `/get-email-prefill-data/${id}/${inventoryRequestType}`, id);    
    }

    getNikoEmailPrefillData(id, inventoryRequestType) {
        return super.get(this.base + `/get-niko-email-prefill-data/${id}/${inventoryRequestType}`, id);    
    }

    sendEmail(resource) {
        return super.create(`${this.base}/send-email`, resource, {
            'content-type': 'multipart/form-data',
        });
    }

    getInventoryFollowUpPrefill(id) {
        return super.get(this.base + '/get-inventory-follow-up-template/{id}', id);
    }

    getInventoryNotReceivedPrefill(id) {
        return super.get(this.base + '/get-inventory-not-received-prefill/{id}', id);
    }

    getInventoryAssistanceRequestPrefill(id) {
        return super.get(this.base + '/get-inventory-assistance-request-prefill/{id}', id);
    }

    getAssistanceEmailPrefillData(id){
        return super.get(this.base + '/get-assistance-email-prefill-data/{id}', id);
    }
     
    checkIsInventoryRequestEligible(id){
        return super.get(this.base + '/check-is-inventory-request-eligible/{id}', id);
    }

    checkIsNikoInventoryRequestEligible(id){
        return super.get(this.base + '/check-is-niko-inventory-request-eligible/{id}', id);
    }

    checkSharedInventoryEmailConditions(id){
        return super.get(this.base + '/check-shared-inventory-email-conditions/{id}', id);
    }

    checkSharedNikoInventoryEmailConditions(id){
        return super.get(this.base + '/check-shared-niko-inventory-email-conditions/{id}', id);
    }
}

export default InventoryRequestRouteService;
